export enum AuthenticationType {
  NONE = 'NONE',
  BASIC = 'BASIC',
  SIGNATURE = 'SIGNATURE'
}
